var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUniqueReferrers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2059 12.2814C21.2059 9.36932 18.8581 7 15.9724 7C13.0868 7 10.7392 9.36932 10.7392 12.2814C10.7392 14.0108 11.5671 15.5489 12.844 16.5127C9.43463 17.7968 7 21.1162 7 24.9992H8.6036C8.6036 20.8988 11.9094 17.5629 15.9724 17.5629C18.8581 17.5629 21.2059 15.1936 21.2059 12.2814ZM15.9724 15.9446C13.9711 15.9446 12.3426 14.3012 12.3426 12.2814C12.3426 10.2617 13.9711 8.61853 15.9724 8.61853C17.9738 8.61853 19.602 10.2617 19.602 12.2814C19.602 14.3012 17.9738 15.9446 15.9724 15.9446Z",
    fill: "url(#paint0_linear_13_1723)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6633 16.6008L20.5293 17.7452L21.8957 19.1239H21.028C18.5453 19.1239 16.5241 21.1622 16.522 23.6676L16.5208 24.9985L18.1244 25L18.1256 23.6689C18.1269 22.0552 19.4289 20.7422 21.028 20.7422H21.9651L20.5293 22.1909L21.6633 23.3353L25 19.968L21.6633 16.6008Z",
    fill: "url(#paint1_linear_13_1723)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_1723",
    x1: 14.1029,
    y1: 7,
    x2: 14.1029,
    y2: 24.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF81A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62A5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_1723",
    x1: 20.7604,
    y1: 16.6008,
    x2: 20.7604,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF81A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62A5D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniqueReferrers);
export default __webpack_public_path__ + "static/media/uniqueReferrers.99e06e08716628e9b4d1c3ba4ddee6b7.svg";
export { ForwardRef as ReactComponent };